import { memo, useState } from 'react'
import AddCategoriesModal from '../modal/AddCategoriesModal'

function AddCategoriesButton({ customerTypes, setCustomerTypes }) {
  const [newCategories, setShowModal] = useState(false)

  return (
    <>
      <button
        type={'button'}
        onClick={() => setShowModal(true)}
        className="w-full md:w-fit shadow-add-more h-11 mx-auto px-5 py-2.5 text-md font-medium text-white
                flex items-center justify-center bg-blue rounded-md hover:bg-link
                transition-all duration-300 ease-linear whitespace-nowrap"
      >
        <span className={'text-white pl-2'}>افزودن دسته بندی</span>
        <i className={'icon-add text-white'} />
      </button>
      {newCategories && (
        <AddCategoriesModal
          customerTypes={customerTypes}
          setCustomerTypes={setCustomerTypes}
          setShowModal={setShowModal}
        />
      )}
    </>
  )
}

export default memo(AddCategoriesButton)

// ******************************************
// ******************************************
// ******************************************
